import Vue from 'vue';
import Vuex from 'vuex';
import navigation_drawer from '@/plugins/vuex/modules/navigation_drawer';
import session from '@/plugins/vuex/modules/session';
import customer_segment from '@/plugins/vuex/modules/customer_segment';
import broadcast from '@/plugins/vuex/modules/broadcast';
import diy from '@/plugins/vuex/modules/diy';
import order from '@/plugins/vuex/modules/ecommerce/order';
import request from '@/plugins/vuex/modules/inquiry/request';
import vouchers from '@/plugins/vuex/modules/super_mini_app/vouchers';
import route from '@/plugins/vuex/modules/route';
Vue.use(Vuex);
/**
 * Implement Vuex Store Modules
 * https://vuex.vuejs.org/guide/modules.html
 * Prevent Store object to bloat by moving Component Scoped Store Objects
 * into its own modules.
 */
export default new Vuex.Store({
    state: {
        appUUID: '',
        appName: '',
        productComponentUUID: '',
        appModules: [],
        toggleAlert: false,
        alertMessage: '',
        alertType: 'success',
        componentKeyword: '',
        appActivePage: {},
        toggleConfirmation: false,
        readySuccessMessage: false,
        todoSuccessMessage: null,
        requestOnFlight: false,
        displayHomeNav: true,
        hideDeactivationReminder: false,
        lastDayGracePeriodReminder: false,
        uploadingImage: false,
        viewLayoutMode: 'grid',
        resellerUUID: '',
        isAffiliateMerchant: false,
        userUUID: '',
        storeLaunchPrompt: {},
        formData: {},
        selectedFilter: 'all',
        selectedRecipient: {},
        recipients: [],
        appGlobalId: '',
        selectedFbpost: {},
        isInboxManagerAllowedApp: false,
        notificationFormData: {},
        adAccountId: '',
        adCampaignObjective: '',
        adCampaignId: '',
        adSetId: '',
        adSetGoal: '',
        mayaDeactivationEndDate: '',
        showMayaReminder: {},
        sentimentAnalysisEnabled: false,
    },
    getters: {
        appUuid(state) {
            return state.appUUID;
        },
        appName(state) {
            return state.appName;
        },
        productComponentUuid(state) {
            return state.productComponentUUID;
        },
        toggleConfirmation(state) {
            return state.toggleConfirmation;
        },
        readySuccessMessage(state) {
            return state.readySuccessMessage;
        },
        todoSuccessMessage(state) {
            return state.todoSuccessMessage;
        },
        requestOnFlight(state) {
            return state.requestOnFlight;
        },
        uploadingImage(state) {
            return state.uploadingImage;
        },
        appActivePage(state) {
            return state.appActivePage;
        },
        hideDeactivationReminder(state) {
            return state.hideDeactivationReminder;
        },
        lastDayGracePeriodReminder(state) {
            return state.lastDayGracePeriodReminder;
        },
        viewLayoutMode(state) {
            return state.viewLayoutMode;
        },
        resellerUuid(state) {
            return state.resellerUUID;
        },
        isAffiliateMerchant(state) {
            return state.isAffiliateMerchant;
        },
        userUuid(state) {
            return state.userUUID;
        },
        storeLaunchPrompt(state) {
            return state.storeLaunchPrompt;
        },
        formData(state) {
            return state.formData;
        },
        selectedFilter(state) {
            return state.selectedFilter;
        },
        selectedRecipient(state) {
            return state.selectedRecipient;
        },
        appGlobalId(state) {
            return state.appGlobalId;
        },
        recipients(state) {
            return state.recipients;
        },
        selectedFbpost(state) {
            return state.selectedFbpost;
        },
        isInboxManagerAllowedApp(state) {
            return state.isInboxManagerAllowedApp;
        },
        notificationFormData(state) {
            return state.notificationFormData;
        },
        adAccountId(state) {
            return state.adAccountId;
        },
        adCampaignObjective(state) {
            return state.adCampaignObjective;
        },
        adCampaignId(state) {
            return state.adCampaignId;
        },
        adSetId(state) {
            return state.adSetId;
        },
        adSetGoal(state) {
            return state.adSetGoal;
        },
        mayaDeactivationEndDate(state) {
            return state.mayaDeactivationEndDate;
        },
        sentimentAnalysisEnabled(state) {
            return state.sentimentAnalysisEnabled;
        },
    },
    mutations: {
        resetAppState(state) {
            state.appUUID = '';
            state.appName = '';
            state.productComponentUUID = '';
            state.storeLaunchPrompt = {};
        },
        clearAlertMessage(state) {
            state.alertMessage = '';
        },
        setAppActivePage(state, page) {
            Vue.set(state, 'appActivePage', page);
        },
        populateAppUUID(state, UUID) {
            state.appUUID = UUID;
        },
        populateAppName(state, name) {
            state.appName = name;
        },
        populateProductComponentUUID(state, UUID) {
            state.productComponentUUID = UUID;
        },
        populateAppModules(state, payload) {
            state.appModules = payload;
        },
        populateAlertMessage(state, message) {
            state.alertMessage = message;
        },
        populateComponentKeyword(state, keyword) {
            state.componentKeyword = keyword.toLowerCase();
        },
        toggleAlert(state, toggle = true) {
            state.toggleAlert = toggle;
        },
        setAlertType(state, alertType) {
            state.alertType = alertType;
        },
        showConfirmationDialog(state) {
            state.toggleConfirmation = true;
        },
        hideConfirmationDialog(state) {
            state.toggleConfirmation = false;
        },
        toggleReadySuccessMessage(state, value) {
            state.readySuccessMessage = value;
        },
        setTodoSuccessMessage(state, message) {
            state.todoSuccessMessage = message;
        },
        resetTodoSuccessMessage(state) {
            state.todoSuccessMessage = null;
        },
        requestOnFlight(state) {
            state.requestOnFlight = true;
        },
        uploadingOnProgress(state) {
            state.uploadingImage = true;
        },
        uploadingDone(state) {
            state.uploadingImage = false;
        },
        requestDone(state) {
            state.requestOnFlight = false;
        },
        hideDeactivationReminderDialog(state, val) {
            state.hideDeactivationReminder = val;
        },
        lastDayGracePeriodReminderDialog(state, val) {
            state.lastDayGracePeriodReminder = val;
        },
        setViewLayoutMode(state, mode) {
            state.viewLayoutMode = mode;
        },
        populateResellerUUID(state, UUID) {
            state.resellerUUID = UUID;
        },
        setIsAffiliateMerchant(state, val) {
            state.isAffiliateMerchant = val;
        },
        populateUserUUID(state, UUID) {
            state.userUUID = UUID;
        },
        setStoreLaunchPrompt(state, prompt) {
            state.storeLaunchPrompt = prompt;
        },
        setFormData(state, data) {
            state.formData = data;
        },
        resetFormData(state) {
            state.formData = {};
        },
        setSelectedFilter(state, filter) {
            state.selectedFilter = filter;
        },
        setSelectedRecipient(state, item) {
            state.selectedRecipient = item;
        },
        setAppGlobalId(state, id) {
            state.appGlobalId = id;
        },
        setRecipients(state, recipients) {
            state.recipients = recipients;
        },
        setSelectedFbpost(state, fbPost) {
            state.selectedFbpost = fbPost;
        },
        setIsInboxManagerAllowedApp(state, val) {
            state.isInboxManagerAllowedApp = val;
        },
        setNotificationFormData(state, data) {
            state.notificationFormData = data;
        },
        setAdAccountId(state, data) {
            state.adAccountId = data;
        },
        setAdCampaignId(state, data) {
            state.adCampaignId = data;
        },
        setAdCampaignObjective(state, data) {
            state.adCampaignObjective = data;
        },
        setAdSetId(state, data) {
            state.adSetId = data;
        },
        setAdSetGoal(state, data) {
            state.adSetGoal = data;
        },
        setMayaDeactivationEndDate(state, date) {
            state.mayaDeactivationEndDate = date;
        },
        setShowMayaReminder(state, val) {
            state.showMayaReminder = val;
        },
        setSentimentAnalysisEnabled(state, val) {
            state.sentimentAnalysisEnabled = val;
        },
    },
    modules: {
        navigation_drawer,
        session,
        customer_segment,
        broadcast,
        diy,
        order,
        request,
        vouchers,
        route,
    },
});
